const disbursementStatusConfig = {
    draft: {
        text: 'Entwurf',
        color: 'grey-3',
        textColor: 'primary',
    },
    submitted: {
        text: 'In Prüfung',
        color: 'grey-3',
        textColor: 'primary',
    },
    approved: {
        text: 'Genehmigt',
        color: 'grey-3',
        textColor: 'positive',
    },
    disbursed: {
        text: 'Ausgezahlt',
        color: 'grey-3',
        textColor: 'positive',
    },
    problem: {
        text: 'Klärungsbedarf',
        color: 'grey-3',
        textColor: 'warning',
    },
    rejected: {
        text: 'Abgelehnt',
        color: 'grey-3',
        textColor: 'negative',
    },
    archived: {
        text: 'Archiviert',
        color: 'grey-3',
        textColor: 'positive',
    },
};

export default disbursementStatusConfig;
